/**
 * @file
 * JS functions for Product modular page.
 */

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.modular_product = {
    attach: function (context, settings) {
      var headerImage = $(".field--name-field-header-fallback-image IMG");
      $(window).on("scroll", function () {
        if(headerImage.hasClass("is-absolute") && $(window).scrollTop() < 2500) {
          headerImage.removeClass("is-absolute");
        }
        else if(!headerImage.hasClass("is-absolute") && $(window).scrollTop() > 3500) {
          headerImage.addClass("is-absolute");
        }
      });


      $(".paragraph--type--video-gallery .video").each(function(){
        var thumbnail = $(this).find(".module-video-gallery-video");
        var wrapper = $(this);
        thumbnail.on('click', function(){
          Drupal.behaviors.modular_product.hideVideoGalleryVideos();
          var iframe = wrapper.find("iframe");
          iframe.attr("width", thumbnail.width());
          iframe.attr("height", thumbnail.height());
          iframe.attr("src", iframe.data("url"));
          iframe.css("display", "block");
          thumbnail.css("display", "none");
        });
      });

      

      var iframe = document.querySelector('.paragraph--type--single-video iframe');

      if (iframe) {
        var player = new Vimeo.Player(iframe);
        $('.paragraph--type--single-video .video-controls__resume').on('click', function () {
          Drupal.behaviors.modular_product.resumeSingleVideo();
        });

        $('.paragraph--type--single-video .video-controls__pause').on('click', function () {
          Drupal.behaviors.modular_product.stopSingleVideo();
        });
      }

      $('.show-more-button', context ).each(function() {
        $(this).on('click', function(){
          $(this).parent().parent().find('.field__item').css('display', 'block');
          $(this).remove();
        });
      });

    },

    hideVideoGalleryVideos: function(){
      var videos = $(".paragraph--type--video-gallery .video");
      videos.each(function(){
        var thumbnail = $(this).find(".module-video-gallery-video, .module-single-video-video");
        var iframe = $(this).find("iframe");
        thumbnail.css("display", "block");
        iframe.css("display", "none");
        iframe.attr("src", "");
      });
    },

    stopSingleVideo: function () {
      var iframe = document.querySelector('.paragraph--type--single-video iframe');
      if (iframe) {
        var player = new Vimeo.Player(iframe);
        player.pause();
        $('.paragraph--type--single-video .video-controls__resume').show();
        $('.paragraph--type--single-video .video-controls__pause').hide();
      }
    },
    resumeSingleVideo: function () {
      var iframe = document.querySelector('.paragraph--type--single-video iframe');
      if (iframe) {
        var player = new Vimeo.Player(iframe);
        player.play();
        $('.paragraph--type--single-video .video-controls__pause').show();
        $('.paragraph--type--single-video .video-controls__resume').hide();
      }
    }
  };

})(jQuery, Drupal);
